import axios from 'axios';

const axiosInstance2ndGen = axios.create({
    baseURL: 'https://europe-west3-digitalna-kartica.cloudfunctions.net'
});

export default axiosInstance2ndGen;

